import React from 'react';
import { Paper } from 'library';

import './TableSectionWrapper.scss';

const TableSectionWrapper = ({ theme, children }) => {
  return (
    <Paper className="TableSectionWrapper" theme={theme}>
      <div className="TableSectionWrapperContent">{children}</div>
    </Paper>
  );
};

export default TableSectionWrapper;
